import { fetchDownloadDicomSeries } from '~/backend/connector-api/connector-components';
import { handleError } from '~/utils/errors';
import { fetchGetTaskError, fetchGetTaskResult } from './connector-components';

export const downloadDicomSeries = async (
    studyId: string,
    seriesId: string
): Promise<Blob | undefined> => {
    try {
        const variables = {
            pathParams: {
                studyId,
                seriesId,
            },
            queryParams: {},
        };

        const blob = await fetchDownloadDicomSeries(variables);
        return blob;
    } catch (error) {
        handleError(error, `Error downloading DICOM series: ${error}`);
    }
};

export const downloadErrors = async (
    id: string,
    errors: string[]
): Promise<File[]> => {
    try {
        return await Promise.all(
            errors.map(async (path) => {
                const blob = await fetchGetTaskError({
                    pathParams: { taskID: id, errorPath: path },
                });
                return new File([blob], path);
            })
        );
    } catch (error) {
        handleError(error, `Failed to download files for result ID ${id}`);
        return [];
    }
};

export const downloadResults = async (
    id: string,
    results: string[]
): Promise<File[]> => {
    try {
        return await Promise.all(
            results.map(async (path) => {
                const blob = await fetchGetTaskResult({
                    pathParams: { taskID: id, resultPath: path },
                });
                return new File([blob], path);
            })
        );
    } catch (error) {
        handleError(error, `Failed to download files for result ID ${id}`);
        return [];
    }
};
